import { Component, OnInit } from '@angular/core';
import { TranslationLoaderFacade } from './localization/translation-loader.facade';
import { LocalizationService } from '@progress/kendo-angular-l10n';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  constructor(
    private translationLoaderFacade: TranslationLoaderFacade) { }

  ngOnInit() {
  }

}
